<template>
  <v-alert
    v-if="latestChangelog"
    color="primary"
    text
    dense
    @click="openChangelogsList"
    style="cursor: pointer"
  >
    <div class="d-flex align-center gap-4">
      <v-icon color="primary" large>
        {{ categories[latestChangelog?.category]?.icon }}
      </v-icon>
      <div class="d-flex flex-column">
        <span>
          <v-chip color="primary" x-small label>
            {{ categories[latestChangelog?.category]?.text }}
          </v-chip>
        </span>
        <h6 class="mb-0">{{ latestChangelog?.title }}</h6>
        <small> Clique para saber mais </small>
      </div>
    </div>
  </v-alert>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      categories: {
        NEW_FEATURE: { text: "Nova Funcionalidade", icon: "mdi-plus" },
        PERFORMANCE: {
          text: "Atualização de Desempenho",
          icon: "mdi-speedometer",
        },
        SECURITY: {
          text: "Atualização de Segurança",
          icon: "mdi-shield-check",
        },
        BUG_FIX: { text: "Correção de Bug", icon: "mdi-bug" },
        NEW_API: { text: "Nova API", icon: "mdi-api" },
        NEW_REPORT: { text: "Novo Relatório", icon: "mdi-chart-box" },
        NEW_UI: { text: "Nova Interface", icon: "mdi-palette" },
        NEW_TOOL: { text: "Nova Ferramenta", icon: "mdi-wrench" },
        OTHER: { text: "Nova Atualização", icon: "mdi-shimmer" },
      },
    };
  },
  computed: {
    ...mapGetters("changelog", ["latestChangelog"]),
  },
  methods: {
    openChangelogsList() {
      this.$root.$emit("open-changelogs-list");
    },
  },
};
</script>
